import { render, staticRenderFns } from "./ui-modal-confirm.vue?vue&type=template&id=2ddc0049&"
import script from "./ui-modal-confirm.vue?vue&type=script&lang=js&"
export * from "./ui-modal-confirm.vue?vue&type=script&lang=js&"
import style0 from "./ui-modal-confirm.vue?vue&type=style&index=0&id=2ddc0049&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports